import React from "react"
import { Box, Typography } from "@mui/material"
import { COLORS } from "../../../../utils"

const STEPS = ["Carte", "Volume", "En attente client", "Prévisionnel validé", "Version définitive"]

const RecipeStepper = ({ activeStep = 0 }) => (
  <Box className="flexRow" sx={sx.row}>
    {STEPS.map((label, i) => {
      const circleSx = { ...sx.circle, ...(i === activeStep ? sx.circleActive : sx.circleInactive) }
      const labelSx = { ...sx.label, ...(i === activeStep ? sx.labelActive : {}) }
      return (
        <React.Fragment key={label}>
          {i > 0 && <Box sx={sx.line} />}
          <Box className="flexColumn center" sx={sx.step}>
            <Box className="flexClassicCenter" sx={circleSx}>{i + 1}</Box>
            <Typography sx={labelSx}>{label}</Typography>
          </Box>
        </React.Fragment>
      )
    })}
  </Box>
)

export default RecipeStepper

const sx = {
  row: { alignItems: "flex-start", p: "32px 20px", maxWidth: "1120px", m: "0 auto", width: "100%", flexShrink: 0 },
  step: { textAlign: "center", gap: "6px", width: "74px", flexShrink: 0 },
  circle: { width: 24, height: 24, borderRadius: "50%", fontSize: 12, fontWeight: 500 },
  circleActive: { bgcolor: COLORS.PRIMARY_COLOR, color: COLORS.WHITE },
  circleInactive: { bgcolor: COLORS.LIGHT_GREY_3, color: COLORS.DISABLED },
  label: { fontSize: 12, color: COLORS.DARK_GREY },
  labelActive: { color: COLORS.PRIMARY_COLOR, fontWeight: 500 },
  line: { flex: 1, height: "1px", bgcolor: COLORS.DEFAULT_GREY, mt: "12px" },
}
